export const IMAGE_EXTENSIONS = [
  ".jpg",
  ".jpeg",
  ".png",
  ".gif",
  ".bmp",
  ".webp",
  ".svg",
  ".tiff",
  ".heic",
  ".heif",
];

export const VIDEO_EXTENSIONS = [
  ".mp4",
  ".webm",
  ".mkv",
  ".ogv",
  ".ogg",
  ".avi",
  ".mov",
  ".wmv",
  ".rm",
  ".rmvb",
  ".flv",
  ".f4v",
  ".f4p",
  ".f4a",
  ".f4b",
  ".m3u8",
  ".hevc",
  ".h265",
  ".265",
];

export const AUDIO_EXTENSIONS = [
  ".mp3",
  ".flac",
  ".aac",
  ".oga",
  ".mogg",
  ".wav",
  ".wma",
  ".m4a",
  ".m4b",
  ".m4p",
  ".opus",
  ".amr",
];

export const TEXT_EXTENSIONS = [
  ".txt",
  ".log",
  ".xml",
  ".yaml",
  ".yml",
  ".ini",
  ".md",
  ".tsv",
  ".csv",
];

export const CODE_EXTENSIONS = [
  ".html",
  ".htm",
  ".css",
  ".js",
  ".ts",
  ".py",
  ".java",
  ".c",
  ".cpp",
  ".h",
  ".php",
  ".rb",
  ".sh",
  ".bat",
  ".sql",
];
